window.Ebbot = {
	botId: '178e57ff-86c7-40e3-b484-48f03db71d53',
};

!(function (doc) {
	const e = 'init-js-widget';

	if (!doc.getElementById(e)) {
		var i = doc.createElement('script');
		i.id = e;
		i.src =
			'https://ebbot-v2.storage.googleapis.com/ebbot-web/init.js?t=' +
			Math.random();
		doc.querySelector('body').appendChild(i);

		document.body.dispatchEvent(new Event('ebbotInit'));
	}
})(document);

(() => {
	const ebbotTriggers = document.querySelectorAll('[data-ebbot-scenario]');

	if (ebbotTriggers.length) {
		ebbotTriggers.forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				e.preventDefault();

				if(window.Ebbot.isHidden()) {
					window.Ebbot.show();
				}

				if(window.Ebbot.isChatWindowClosed()) {
					window.Ebbot.openChatWindow();
				}

				window.Ebbot.triggerScenario({
					scenario: trigger.dataset.scenario,
				});
			});
		});
	}
})();
